import { goRequest } from '../utils/httpClientTs';
import { ScheduledTask } from '../types/scheduledTasks';

/**
 * Get all scheduled tasks (admin only)
 * @returns Promise<ScheduledTask[]>
 */
export const getScheduledTasks = async (): Promise<ScheduledTask[]> => {
  return goRequest<ScheduledTask[]>({
    url: '/api/admin/scheduled-tasks',
    method: 'GET',
  });
};
